export class ApiRequest {
  Header: ApiRequestHeader;
  Body: any;

  constructor(params: Omit<ApiRequest, 'Header'>) {
    this.Header = new ApiRequestHeader();
    this._setRequestBody(params.Body);
  }

  private _setRequestBody(body: any): void {
    if (Object.keys(body).length) {
      this.Body = body;
    }
  }
}

class ApiRequestHeader {
  Mitt = 'PORTALE_DISTRIBUZIONE';
  Dest = 'Neta2D_API';
  TicketInt = null;
  TicketExt = null;
  Tipo_Interfaccia = null;
  Data: Date;
  IsSimula = false;

  constructor() {
    this.Data = new Date();
  }
}
